import ClassifiedMetadataBox from './ClassifiedMetadataBox';

const ContactBookPreview = ({ classified, coverUrl }) => <div className="contactbookpreview">
  <div className="book-cover contactbookpreview__cover">
    <img src={coverUrl} alt=""/>
  </div>
  <ClassifiedMetadataBox className="contactbookpreview__metadata" classified={classified}/>
</div>;

export default ContactBookPreview;
